import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { accountingApi } from '../../services/accountingApi';
import AccountingFilters from '../../components/accounting/AccountingFilters';
import MovementForm from '../../components/accounting/MovementForm';
import MovementsTable from '../../components/accounting/MovementsTable';
import '../../styles/accounting.css';

export default function AccountingMovements() {
    const [meta, setMeta] = useState({});
    const [rows, setRows] = useState([]);
    const [filters, setFilters] = useState({ from: '2026-07-03', to: new Date().toISOString().slice(0, 10) });

    const loadMeta = async () => setMeta(await accountingApi.meta());
    const search = async () => setRows((await accountingApi.listMovements(filters)).rows || []);

    useEffect(() => { loadMeta(); search(); }, []);

    return (
        <div>
            <Header namePage="accountingPage" />
            <section className="sectionBody sectionBodyAccounting">
                <div className="containerCustom containerBody">
                    <main className="accountingPage">
                        <header className="accHero"><div><span>Contabilidad</span><h1>Registro de ingresos, egresos y transferencias</h1><p>Fecha habilitada desde el 03/07/2026. El rol 8 solo puede crear registros; no puede editar ni anular.</p></div></header>
                        <AccountingFilters meta={meta} filters={filters} setFilters={setFilters} onSearch={search} />
                        <MovementForm meta={meta} onSaved={search} />
                        <MovementsTable rows={rows} reload={search} permissions={meta.permissions} />
                    </main>
                </div>
            </section>
            <Footer />
        </div>
    );
}
